<template>
  <div v-loading="loading">
    <div class="header-actions">
      <search-input
        placeholder="Поиск по названию"
        style="width: 300px"
        v-model="filters.search"
        @change="filtersChanged"
      >
      </search-input>
      <div slot="right">
        <div class="el-row--flex">
          <el-button
            type="primary"
            size="small"
            icon="fas fa-plus"
            @click="openEditDialog"
          >
            Добавить индикатор
          </el-button>
        </div>
      </div>
    </div>

    <div class="indicators-block">
      <el-table :data="indicators" border>
        <el-table-column prop="name" label="Название" width="500"></el-table-column>
        <el-table-column prop="description" label="Описание"></el-table-column>
        <el-table-column width="90" align="right" label="Действия">
          <template v-slot="scope">
            <el-popconfirm
              style="float:left"
              confirm-button-text='Да'
              cancel-button-text='нет'
              icon="el-icon-question"
              title="Вы уверены, что хотите удалить индикатор?"
              @confirm="deleteIndicator(scope.row)"
            >
              <el-button
                slot="reference"
                class="table-action-button"
                size="mini"
                round
                icon="far fa-trash-alt"
              >
              </el-button>
            </el-popconfirm>
            <el-button
              class="table-action-button"
              size="mini"
              round
              icon="fas fa-pen"
              @click="openEditDialog(scope.row)"
            >
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <indicator-edit-dialog
      ref="editDialog"
      @indicator-saved="loadIndicators"
    >
    </indicator-edit-dialog>
  </div>
</template>

<script>
import IndicatorEditDialog from "@/modules/evaluation/components/indicator/IndicatorEditDialog.vue";
import SearchInput from "@/components/filters/SearchInput.vue";

export default {
  name: "indicators-component",
  components: {IndicatorEditDialog, SearchInput},
  data() {
    return {
      loading: false,
      indicators: [],
      filters: {},
    }
  },
  mounted() {
    this.loadIndicators();
  },
  methods: {
    openEditDialog(indicator = {}) {
      this.$refs.editDialog.open(indicator);
    },
    loadIndicators() {
      this.loading = true;
      this.$api.evaluation.indicatorSearch({
        ...this.filters,
        competence_id: this.$route.params.id,
        sort: 'id',
      })
        .then(({data}) => {
          this.indicators = data.indicators;
        })
        .finally(() => {
          this.loading = false;
        })
    },
    deleteIndicator(indicator) {
      this.loading = true;
      this.$api.evaluation.indicatorDelete({
        ids: [indicator.id]
      })
        .then(data => {
          this.$notify.success({
            title: 'Удалено',
            message: 'Индикатор успешно удален'
          });
        })
        .finally(() => {
          this.loadIndicators();
        })
    },
    filtersChanged() {
      this.loadIndicators();
    }
  }
}
</script>

<style lang="scss">
  .indicators-block {
    margin: 25px 0;
  }

  .header-actions {
    display: flex;
    justify-content: space-between;
  }
</style>